import { Navigate } from 'react-router-dom';
import { getAuthRole } from 'features/auth/authSession';

const DashboardRedirectPage = () => {
  const role = getAuthRole();

  if (role === 'locum') {
    return <Navigate to="/dashboard/locum" replace />;
  }

  if (role === 'pharmacy') {
    return <Navigate to="/dashboard/pharmacy" replace />;
  }

  return <Navigate to="/auth/login" replace />;
};

export default DashboardRedirectPage;
